module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-300-normal.woff?5fc4dad051cd968cc43c33c201ceb01d";